import { render, staticRenderFns } from "./bi-yes-no.vue?vue&type=template&id=8ba144dc&"
import script from "./bi-yes-no.vue?vue&type=script&lang=ts&"
export * from "./bi-yes-no.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports